import {
  GOVGR_ERROR_MESSAGE,
  GOVGR_VISUALLY_HIDDEN,
} from "../../conf/styles/GovGrFileInput";

const ErrorText = ({ error }) => {
  return (
    <p className={GOVGR_ERROR_MESSAGE}>
      <span className={GOVGR_VISUALLY_HIDDEN}>Λάθος:</span> {error}
    </p>
  );
};

export default ErrorText;
